export default __webpack_public_path__ + "static/media/Beard_6_C4.01fefdb2.svg";